//https://igorescobar.github.io/jQuery-Mask-Plugin/docs.html
const inputTel = (id) => {
    if ( id.length ) {
        id.mask('+7 (000) 000-00-00',  {placeholder: "+7 (xxx) xxx-xx-xx"});
    }
}